import React from "react"

import { useAuth } from "@/contexts/AuthContext"
import { TranscribersPaymentsProvider } from "@/contexts/TranscribersPaymentsContext.tsx"
import Splash from "@/components/splash"
import { useParams } from 'react-router-dom'
import { Toaster } from "@/components/ui/toaster"

import PaymentsHeader from "./PaymentsHeader.tsx"
import PaymentsHistory from "./PaymentsHistory.tsx"
import PaymentDetails from "./PaymentDetails.tsx"
import OrderHeader from "../order/OrderHeader.tsx"
import { OrderProvider } from "@/contexts/OrderContext.tsx"
import { Card } from "@/components/ui/card.tsx"

// PaymentDetails should take the rest of the space

export default function Payments() {
    const { user } = useAuth()
    const { transcriber_payment_id } = useParams()

    if (!user) return <Splash>Chargement du compte...</Splash>;

    return (
        <TranscribersPaymentsProvider>
            <div className="flex flex-col h-screen min-h-0">
                <OrderHeader title={"Paiements"} />

                <div className="flex-grow flex gap-4 min-h-0 p-4">
                    <div className="w-1/4 min-h-0">
                        <PaymentsHistory />
                    </div>

                    {transcriber_payment_id && (
                        <Card className="w-3/4 p-4 min-h-0">
                            <PaymentDetails transcriber_payment_id={transcriber_payment_id} />
                        </Card>
                    )}
                </div>
            </div>
        </TranscribersPaymentsProvider>
    )
}